import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRegistration } from '../context/RegistrationContext';
import RouteLoadingGate from './RouteLoadingGate';

interface ProtectedRouteProps {
  children: React.ReactElement;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, redirectPath = '/login' }) => {
  const { isRegistered, isLoggingOut } = useRegistration();
  const location = useLocation();

  if (isLoggingOut) {
    return <RouteLoadingGate message="Signing out…" minHeight="40vh" />;
  }

  if (!isRegistered) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;

